export default __webpack_public_path__ + "static/media/workers.063717ed.jpg";